import { render, staticRenderFns } from "./Navegacao.vue?vue&type=template&id=288231f2&scoped=true"
import script from "./Navegacao.vue?vue&type=script&setup=true&lang=js"
export * from "./Navegacao.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Navegacao.vue?vue&type=style&index=0&id=288231f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288231f2",
  null
  
)

export default component.exports